import { IExceptionParams } from '../models'

export const getEmptyExceptionParams = (): IExceptionParams => ({
  ExcDomain: '',
  Group: '',
  ExcCode: '',
  ExceptionReason: [],
  ExceptionCategoryGUID: [],
  BusinessJustification: '',
  ExceptionProofs: [],
  IsCycleEffect: false,
  FlaggingEffect: '',
  IsMultiSelect: false,
  IsExceptionRequestPartnerThresholdConfirmed: false,
})

export const getCommonFieldsEmpty = (): Pick<
  IExceptionParams,
  | 'ExceptionReason'
  | 'IsCycleEffect'
  | 'FlaggingEffect'
  | 'IsMultiSelect'
  | 'IsExceptionRequestPartnerThresholdConfirmed'
  | 'ExceptionCategoryGUID'
> => ({
  ExceptionReason: [],
  ExceptionCategoryGUID: [],
  IsCycleEffect: false,
  FlaggingEffect: '',
  IsMultiSelect: false,
  IsExceptionRequestPartnerThresholdConfirmed: false,
})
